import React, { useEffect, useRef, useState, useCallback } from "react";
import { Tabs, Tab } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { HashLoader } from "react-spinners";
import { Toaster, toast } from "react-hot-toast";
import HistoryList from "./historyList";
import OptionToSearch from "../SalesShared/SearchBar/OptionToSearch";

// const HistoryPage = ({
//   fetchHistoryThunk,
//   historySelector,
//   loadingSelector,
//   errorSelector,
//   type,
//   tabLabels,
// }) => {
//   const dispatch = useDispatch();

//   const getInitialTabValue = () => {
//     const stored = localStorage.getItem("PAGEData");
//     if (stored) return stored;
//     return type === "delivery" ? "Loading" : "Open";
//   };

//   const [value, setValue] = useState(getInitialTabValue);
//   const historyData = useSelector(historySelector);
//   const loadings = useSelector(loadingSelector);
//   const errors = useSelector(errorSelector);
//   const [offset, setOffset] = useState(0);
//   const [hasMore, setHasMore] = useState(true);
//   const [historyList, setHistoryList] = useState([]);
//   const [search, setSearch] = useState(false);
//   const [inProgress, setInProgress] = useState({
//     deliveryHistory: false,
//     invoiceHistory: false,
//     deliveryItems: false,
//     invoiceItems: false,
//     searchHistory: false,
//   });

// const { searchInvoiceDeliver, error, loading } = useSelector(
//   (state) => state.Invoice
// );

//   const scrollRef = useRef(null);

//   useEffect(() => {
//     if (!historyData) {
//       resetAndFetch(value, type);
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);

//   const isLoading = () =>
//     loadings.DeliveryHistory || loadings.InvoiceHistory || loading.searchInvoiceDeliver;

//   const resetAndFetch = (newValue, currentType) => {
//     debugger
//     setOffset(0);
//     setHasMore(true);

//     setHistoryList([]);
//     if (currentType === "delivery") {
//       setInProgress((prev) => ({ ...prev, deliveryHistory: true }));
//     } else {
//       setInProgress((prev) => ({ ...prev, invoiceHistory: true }));
//     }
//     dispatch(fetchHistoryThunk({ status: newValue, offsetValue: 0 }));
//   };

// useEffect(() => {
//   if (search) {
//     if (inProgress.searchHistory && searchInvoiceDeliver) {
//       setHistoryList(searchInvoiceDeliver);
//     } else if (!inProgress.searchHistory && error?.searchInvoiceDeliverError) {
//       setHistoryList([]);
//     }
//     setInProgress((prev) => ({ ...prev, searchHistory: false }));
//   } else {
//     setHistoryList(historyData || []);
//   }
// }, [inProgress, search, searchInvoiceDeliver, error, historyData]);

//   const handleScroll = useCallback(() => {
//     if (search) return;

//     const scrollContainer = scrollRef.current;
//     if (!scrollContainer) return;

//     const { scrollTop, scrollHeight, clientHeight } = scrollContainer;
//     const isNearBottom = scrollTop + clientHeight + 100 >= scrollHeight;

//     if (isNearBottom && hasMore && !isLoading()) {
//       const nextOffset = offset + 100;
//       setOffset(nextOffset);

//       if (type === "delivery") {
//         setInProgress((prev) => ({ ...prev, deliveryHistory: true }));
//       } else {
//         setInProgress((prev) => ({ ...prev, invoiceHistory: true }));
//       }
//       dispatch(fetchHistoryThunk({ status: value, offsetValue: nextOffset }));
//     }
//   }, [offset, hasMore, value, type, dispatch, loadings, search]);

//   useEffect(() => {
//     const scrollContainer = scrollRef.current;
//     if (!scrollContainer) return;
//     scrollContainer.addEventListener("scroll", handleScroll);
//     return () => scrollContainer.removeEventListener("scroll", handleScroll);
//   }, [handleScroll]);

//   const Checker = () => {
//     if ((inProgress.deliveryHistory || inProgress.invoiceHistory) && historyData) {
//       if (!Array.isArray(historyData) || historyData.length === 0) {
//         // No more data returned, stop loading more on scroll
//         setHasMore(false);
//       } else {
//         setHasMore(true); // data returned, can load more
//       }

//       setHistoryList((prev) =>
//         offset === 0 ? historyData : Array.isArray(prev) ? [...prev, ...historyData] : historyData
//       );

//       if (inProgress.deliveryHistory) {
//         setInProgress((prev) => ({ ...prev, deliveryHistory: false }));
//       }
//       if (inProgress.invoiceHistory) {
//         setInProgress((prev) => ({ ...prev, invoiceHistory: false }));
//       }
//     }

//     if (inProgress.deliveryHistory && errors?.DeliveryHistoryError) {
//       const err = errors.DeliveryHistoryError;
//       setHasMore(false);
//       if (err.errorCode !== 404) toast.error(err.errorMessage);
//       setInProgress((prev) => ({ ...prev, deliveryHistory: false }));
//     }

//     if (inProgress.invoiceHistory && errors?.InvoiceHistoryError) {
//       const err = errors.InvoiceHistoryError;
//       setHasMore(false);
//       if (err.errorCode !== 404) toast.error(err.errorMessage);
//       setInProgress((prev) => ({ ...prev, invoiceHistory: false }));
//     }

// if (inProgress.deliveryItems && errors?.DeliveryItemsError) {
//   toast.error(errors.DeliveryItemsError.errorMessage);
//   setInProgress((prev) => ({ ...prev, deliveryItems: false }));
// }

// if (inProgress.invoiceItems && errors?.InvoiceItemsError) {
//   toast.error(errors.InvoiceItemsError.errorMessage);
//   setInProgress((prev) => ({ ...prev, invoiceItems: false }));
// }
//   };

//   useEffect(() => {
//     Checker();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [errors, inProgress, historyData, hasMore, offset]);

//   const isNormalEmpty = !search && !isLoading() && historyList?.length === 0;

//   const handleChange = (event, newValue) => {
//     setValue(newValue);
//     localStorage.setItem("PAGEData", newValue);
//     setOffset(0);
//     setHasMore(true);
//     setHistoryList([]);

//     if (type === "delivery") {
//       setInProgress((prev) => ({ ...prev, deliveryHistory: true }));
//     } else {
//       setInProgress((prev) => ({ ...prev, invoiceHistory: true }));
//     }
//     dispatch(fetchHistoryThunk({ status: newValue, offsetValue: 0 }));
//   };

//   return (
//     <>
//       <section style={{ width: "100%" }}>
//         <Tabs value={value} onChange={handleChange} className="custom-tabs">
//           {type === "delivery" && <Tab value="Loading" label={tabLabels.loading} />}
//           <Tab value="Open" label={tabLabels.open} />
//           <Tab value="Closed" label={tabLabels.closed} />
//         </Tabs>

//         <div className="d-flex justify-content-center mt-2">
//           <OptionToSearch tabValue={value} setInProgress={setInProgress} SetSearch={setSearch} />
//         </div>

//         {isLoading() && offset > 0 && (
//           <div className="loader-sales">
//             <HashLoader color="#ed1c24" />
//           </div>
//         )}

//         {isNormalEmpty && (
//           <div style={{ padding: "20px", textAlign: "center", color: "#777" }}>
//             <div className="no-orders-container">
//               <p className="no-orders-message">No {value.toLowerCase()} history found</p>
//             </div>
//           </div>
//         )}

//         <div className="History-div" ref={scrollRef} >
//           <HistoryList type={type} value={value} status={value} historyData={historyList} setInProgress={setInProgress} />
//         </div>
//       </section>

//       <Toaster
//         position="top-center"
//         toastOptions={{
//           style: {
//             fontSize: "16px",
//             padding: "16px",
//             width: "400px",
//             borderRadius: "8px",
//           },
//         }}
//       />
//     </>
//   );
// };

// export default HistoryPage;

const PAGE_SIZE = 100; // adjust as per your backend pagination size

const HistoryPage = ({
  fetchHistoryThunk,
  historySelector,
  loadingSelector,
  errorSelector,
  type,
  tabLabels,
}) => {
  const dispatch = useDispatch();

  const getInitialTabValue = () => {
    const stored = localStorage.getItem("PAGEData");
    if (stored) return stored;
    return type === "delivery" ? "Loading" : "Open";
  };

  const [value, setValue] = useState(getInitialTabValue);
  const historyData = useSelector(historySelector);
  const loadings = useSelector(loadingSelector);
  const errors = useSelector(errorSelector);
  const [offset, setOffset] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [historyList, setHistoryList] = useState([]);
  const [search, setSearch] = useState(false);
  const [inProgress, setInProgress] = useState({
    deliveryHistory: false,
    invoiceHistory: false,
    deliveryItems: false,
    invoiceItems: false,
    searchHistory: false,
  });

  const scrollRef = useRef(null);
  const { searchInvoiceDeliver, error, loading } = useSelector(
    (state) => state.Invoice
  );
  const isLoading = () =>
    loadings.DeliveryHistory ||
    loadings.InvoiceHistory ||
    loading.searchInvoiceDeliver;

  // Reset and fetch initial data for new tab or type
  const resetAndFetch = (newValue, currentType) => {
    setOffset(0);
    setHasMore(true);
    setHistoryList([]);
    if (currentType === "delivery") {
      setInProgress((prev) => ({ ...prev, deliveryHistory: true }));
    } else {
      setInProgress((prev) => ({ ...prev, invoiceHistory: true }));
    }
    dispatch(fetchHistoryThunk({ status: newValue, offsetValue: 0 }));
  };

  useEffect(() => {
    
    resetAndFetch(value, type);
  }, []);
  useEffect(() => {
    if (search) {
      if (inProgress.searchHistory && searchInvoiceDeliver) {
        setHistoryList(searchInvoiceDeliver);
        setInProgress((prev) => ({ ...prev, searchHistory: false }));
      } else if (inProgress.searchHistory && error?.searchInvoiceDeliverError) {
        setHistoryList([]);
      }
      
    }

    // else{
    //   setHistoryList(historyData);
    // }
  }, [
    search,
    inProgress,
    searchInvoiceDeliver,
    error,
    historyData,
  ]);
  useEffect(() => {
    if (
      (inProgress.deliveryHistory || inProgress.invoiceHistory) &&
      historyData
    ) {
      if (!Array.isArray(historyData) || historyData.length < PAGE_SIZE) {
        setHasMore(false);
      } else {
        setHasMore(true);
      }
      setHistoryList((prev) =>
        offset === 0 ? historyData : [...prev, ...historyData]
      );
      setInProgress((prev) => ({
        ...prev,
        deliveryHistory: false,
        invoiceHistory: false,
      }));
    }
    if (inProgress.deliveryHistory && errors?.DeliveryHistoryError) {
      const err = errors.DeliveryHistoryError;
      setHasMore(false);
      toast.error(err.errorMessage);
      setInProgress((prev) => ({ ...prev, deliveryHistory: false }));
    }

    if (inProgress.invoiceHistory && errors?.InvoiceHistoryError) {
      const err = errors.InvoiceHistoryError;
      setHasMore(false);
      if (err.errorCode !== 404) toast.error(err.errorMessage);
      setInProgress((prev) => ({ ...prev, invoiceHistory: false }));
    }
    if (inProgress.deliveryItems && errors?.DeliveryItemsError) {
      toast.error(errors.DeliveryItemsError.errorMessage);
      setInProgress((prev) => ({ ...prev, deliveryItems: false }));
    }

    if (inProgress.invoiceItems && errors?.InvoiceItemsError) {
      toast.error(errors.InvoiceItemsError.errorMessage);
      setInProgress((prev) => ({ ...prev, invoiceItems: false }));
    }
  }, [historyData, inProgress, errors, offset]);

  // Scroll event handler
  const handleScroll = useCallback(() => {
    if (search) return;
    const scrollContainer = scrollRef.current;
    if (!scrollContainer) return;
    const { scrollTop, scrollHeight, clientHeight } = scrollContainer;
    const isNearBottom = scrollTop + clientHeight + 100 >= scrollHeight;
    if (isNearBottom && hasMore && !isLoading()) {
      const nextOffset = offset + PAGE_SIZE;
      setOffset(nextOffset);
      if (type === "delivery") {
        setInProgress((prev) => ({ ...prev, deliveryHistory: true }));
      } else {
        setInProgress((prev) => ({ ...prev, invoiceHistory: true }));
      }
      dispatch(fetchHistoryThunk({ status: value, offsetValue: nextOffset }));
    }
  }, [offset, hasMore, search, value, type, dispatch, loadings]);

  // Attach scroll listener
  useEffect(() => {
    const scrollContainer = scrollRef.current;
    if (!scrollContainer) return;
    scrollContainer.addEventListener("scroll", handleScroll);
    return () => scrollContainer.removeEventListener("scroll", handleScroll);
  }, [handleScroll]);

  const isNormalEmpty =
    !isLoading() && historyList && historyList?.length === 0;

  const handleChange = (event, newValue) => {
    setValue(newValue);
    localStorage.setItem("PAGEData", newValue);
    resetAndFetch(newValue, type);
  };

  return (
    <>
      <section style={{ width: "100%" }}>
        <Tabs value={value} onChange={handleChange} className="custom-tabs">
          {type === "delivery" && (
            <Tab value="Loading" label={tabLabels.loading} />
          )}
          <Tab value="Open" label={tabLabels.open} />
          <Tab value="Closed" label={tabLabels.closed} />
        </Tabs>

        <div className="d-flex justify-content-center mt-2">
          <OptionToSearch
            tabValue={value}
            setInProgress={setInProgress}
            SetSearch={setSearch}
          />
        </div>

        {isLoading() && offset > 0 && (
          <div className="loader-sales">
            <HashLoader color="#ed1c24" />
          </div>
        )}

        {isNormalEmpty && (
          <div style={{ padding: "20px", textAlign: "center", color: "#777" }}>
            <div className="no-orders-container">
              <p className="no-orders-message">
                No {value.toLowerCase()} history found
              </p>
            </div>
          </div>
        )}

        <div
          // className="History-div"
          ref={scrollRef}
          style={{ height: "700px", overflowY: "auto" }}
        >
          <HistoryList
            type={type}
            value={value}
            status={value}
            historyData={historyList}
            setInProgress={setInProgress}
          />
        </div>
      </section>

      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            fontSize: "16px",
            padding: "16px",
            width: "400px",
            borderRadius: "8px",
          },
        }}
      />
    </>
  );
};

export default HistoryPage;
